import { STORAGE_KEY_DEVICE_UUID, STORAGE_KEY_INSTALL_SEQ } from '@/constants/storage';

import { getOrCreateTriple } from './triple-storage';

/** 设备注册用：device_uuid（三级存储，见 doc/游客登录.md） */
export function getOrCreateDeviceUuid(): Promise<string> {
    return getOrCreateTriple(STORAGE_KEY_DEVICE_UUID);
}

/** 设备注册用：install_seq（三级存储，见 doc/游客登录.md） */
export function getOrCreateInstallSeq(): Promise<string> {
    return getOrCreateTriple(STORAGE_KEY_INSTALL_SEQ);
}
